import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import ListWithDetails from 'components/Common/ListWithDetails';
import ListBadge from 'components/Common/ListBadge';
import ChatShortcutDetails from 'components/Chat/ChatShortcuts/ChatShortcutDetails';
import './style.scss';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { useAppSelector } from 'careand-redux/store';
import { api } from 'careand-redux/api/ApiThunks';

const ChatShortcuts = props => {
  const dispatch = useAppDispatch();
  const shortcuts = useAppSelector(state => state.chat.shortcuts);

  useEffect(
    () => {
      dispatch(api.Chat.getChatShortcuts())
    },
    [dispatch]
  );

  return (
    <ListWithDetails
      items={[{ name: 'Add New Shortcut', id: 'new-shortcut' }, ...shortcuts]}
      title="Chat Shortcuts"
      renderBadge={shortcut => <ChatShortcutBadge shortcut={shortcut} />}
      onClick={shortcut => {
        props.onSelect(shortcut || {});
      }}
      renderDetails={shortcut => (
        <ChatShortcutDetails
          key={shortcut.id || 'new-shortcut'}
          shortcut={shortcut}
        />
      )}
    />
  );
};

const ChatShortcutBadge = ({ shortcut }) => (
  <ListBadge title={shortcut.name} firstLine={shortcut.value} />
);

ChatShortcuts.propTypes = {
  onSelect: PropTypes.func
};

export default ChatShortcuts;
